


export function getApiInformation(){
    var apiKey = process.env.REACT_APP_API_KEY;
    var apiSecret = process.env.REACT_APP_API_SECRET;
    
    return{
        apiKey,
        apiSecret
    }
}